module.exports = __webpack_public_path__ + "static/gothamhtf-thin-f18617ff58091a80bbcc02ea0c89aac2.woff";